import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';
import { SsoConfigurationsResource } from '../../Types';
import DomainRow from './DomainRow';

interface Props {
  resource: SsoConfigurationsResource;
}

const LoginDomains: React.FC<Props> = ({ resource }) => {
  const { connections, loginDomains } = resource.payload;
  const hasConnections = connections.length > 0;

  return (
    <div>
      <h3 className="text-base font-semibold text-foreground">
        <T kind="Login domains" />
      </h3>
      <div className="mt-3 rounded-lg border border-border bg-card p-6">
        <p className="text-sm text-muted-foreground">
          {hasConnections ? (
            <T kind="Changes take effect immediately for new sign-ins. Connections still waiting on IdP setup can't be selected yet. Domains without a connection use password sign-in." />
          ) : (
            <T kind="All of your domains currently use password sign-in. Assign them to identity providers after you add one." />
          )}
        </p>
        <div className="mt-4 overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="border-b border-border py-2 pr-3 text-left text-sm font-bold text-foreground">
                  <T kind="Domain" />
                </th>
                <th className="border-b border-border py-2 text-left text-sm font-bold text-foreground">
                  <T kind="Sign-in method" />
                </th>
              </tr>
            </thead>
            <tbody>
              {loginDomains.map((loginDomain) => (
                <DomainRow
                  key={loginDomain.id}
                  loginDomain={loginDomain}
                  connections={connections}
                  links={resource.links}
                />
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-4 text-sm text-muted-foreground">
          <T kind="Login domains are verified and added by ExecOnline - contact support to add one." />
        </p>
        {hasConnections && (
          <p className="mt-2 text-sm text-muted-foreground">
            <T kind="People from assigned domains who sign in for the first time get an account automatically (just-in-time provisioning). They only see content they are enrolled in." />
          </p>
        )}
      </div>
    </div>
  );
};

export default observer(LoginDomains);
